import { setAppSpinning, showNotification } from 'app/appSlice'
import CancelInvoiceModal from 'general/components/Modal/CancelInvoiceModal'
// import FindInvoiceModal from 'general/components/Modal/FindInvoiceModal'
import { List, Space, Tooltip } from 'antd'
import invoiceApi from 'api/invoiceApi'
import dayjs from 'dayjs'
import {
  setClearRows,
  setModalsState,
  setSelectedInvoices,
} from 'features/Invoice/invoiceSlice'
import ModalConvertPaper from 'features/Search/components/ModalConvertPaper'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import CustomDataTable from 'general/components/CustomDataTable'

import useFilter from 'hooks/useFilter'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import useRouter from 'hooks/useRouter'
import useSearchDebounce from 'hooks/useSearchDebounce'
import _ from 'lodash'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { shallowEqual } from 'react-redux'
import { useQueryListOrganization } from '../../../../../Invoice/screens/ListInvoice/queries'

import VIButton from 'general/components/eInvoiceComponents/VIButton'
import KTTooltip from 'general/components/eInvoiceComponents/KTTooltip'
import VIModal from '../VIModal'
import ConnectAccount from '../ConnectAccount'
import {
  thunkGetProfile,
  thunkListOrganization,
} from 'features/InPutEInvoice/inputEinvoiceSlice'

function ViewAxionListAccount({ profile, getProfile }) {
  // MARK --- Parmas: ---
  const { t } = useTranslation()
  const { navigate } = useRouter()
  const dispatch = useAppDispatch()

  const { selectedInvoices, toggledClearRows, modalStates } = useAppSelector(
    (state) => state.invoice,
    shallowEqual,
  )

  const [inforSave, setInforSave] = useState({ disabled: false })
  const [listData, setListData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [modalConnectAccountShowing, setModalConnectAccountShowing] =
    useState(false)

  const defaultColumns = [
    {
      name: t('UnitName'),
      minWidth: '300px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="font-weight-bolder m-0 text-maxline-3"
          >
            {row?.organizationName}
          </p>
        )
      },
    },
    {
      name: t('TaxCode'),
      width: '130px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="font-weight-normal m-0 text-maxline-3"
          >
            {row?.taxCode}
          </p>
        )
      },
    },
    {
      name: t('EmailReceiveInvoice'),
      width: '250px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="font-weight-normal m-0 text-maxline-3"
          >
            {row?.invoiceMailbox}
          </p>
        )
      },
    },
    {
      name: t('State'),
      sortable: false,
      width: '130px',
      center: true,
      cell: (row) => {
        return (
          <KTTooltip text={(row?.active ?? true) ? t('Active') : t('InActive')}>
            {(row?.active ?? true) ? (
              <i className="fa-regular fa-circle-check text-primary" />
            ) : (
              <i className="fa-regular fa-times-circle text-danger" />
            )}
          </KTTooltip>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      width: '120px',
      // style: {
      //   position: 'sticky',
      //   right: 0,
      //   backgroundColor: '#fff',
      //   borderLeft: '1px solid #ebedf3',
      // },
      cell: (row) => {
        const isConnected =
          !_.isNull(profile?.Organization?.cqtToken) &&
          !_.isNull(row?.cqtToken) &&
          row?.cqtToken === profile?.Organization?.cqtToken
        return (
          <div className="d-flex align-items-center justify-content-between">
            <VIButton
              text={isConnected ? t('Connected') : t('Connect')}
              className={isConnected ? 'btn-grey' : 'btn-blue'}
              style={{ padding: '8px' }}
              onClick={() => {
                setInforSave(row)
                setModalConnectAccountShowing(true)
                // console.log({ account, row });
                // return;
                // handleConnect(row)
              }}
              disabled={isConnected}
            />
          </div>
        )
      },
    },
  ]

  const getOrganization = async (param) => {
    setIsLoading(true)
    const data = await dispatch(thunkListOrganization(param))
    setListData(data?.payload?.organizations)
    setIsLoading(false)
  }

  useEffect(() => {
    getOrganization()
  }, [])

  return (
    <ContentContainer.Body>
      <CustomDataTable
        columns={defaultColumns}
        dataSource={listData}
        isLoading={isLoading}
        isClickable
        handleDoubleClickRow={(row) => {
          // viewPdfInvoice(row)
        }}
        // isSelectable
        selectedRows={{
          clearSelectedRows: toggledClearRows,
          handleSelectedRows: ({ selectedRows }) =>
            dispatch(setSelectedInvoices(selectedRows)),
          selectableRowSelected: (row) => _.includes(selectedInvoices, row),
        }}
      />
      {/* modal connect account */}
      <VIModal
        titleModal={t('SetupConnection')}
        modalSize="xl"
        show={modalConnectAccountShowing}
        contentModal={
          <ConnectAccount
            inforSave={inforSave}
            profile={profile}
            setModalAddAccountShowing={setModalConnectAccountShowing}
            refetctProfile={getProfile}
            refetctOrganizations={getOrganization}
          />
        }
        closeBtn
        handleSubmit={() => {}}
        onHide={() => {
          setModalConnectAccountShowing(false)
        }}
        // buttonPositive={t('AddAccount')}
        // buttonNegative={t('Close')}
      />
    </ContentContainer.Body>
  )
}

export default ViewAxionListAccount
